// extracted by mini-css-extract-plugin
module.exports = {"hero":"Team-module--hero--1bQbh","teamDetails":"Team-module--teamDetails--ngJAE","heading":"Team-module--heading--thqIT","team":"Team-module--team--zOUQh"};